import React, { useEffect } from "react";
import { Button } from "primereact/button";
import {
  getCategory,
  getSubCategory,
} from "../../store/AsyncMethods/CategoryMethod";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { RESET_ERROR, RESET_SUCCESS } from "../../store/Types/AuthTypes";
import { useNavigate } from "react-router-dom";
import SubCategoriesTable from "./SubCategoriesTable";
import { useTranslation } from "react-i18next";

export default function SubCategoriesMain() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { success, error, user } = useSelector((state) => state.AuthReducer);

  useEffect(() => {
    if (success) {
      toast.success(success);
      dispatch({ type: RESET_SUCCESS });
    }
  }, [success]);

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch({ type: RESET_ERROR });
    }
  }, [error]);

  useEffect(() => {
    if (user) {
      dispatch(getSubCategory());
    }
  }, []);

  return (
    <div className="">
      <div className="flex justify-end">
        <Button
          label={t("add_sub_category")}
          icon="pi pi-plus"
          className="p-primary-btn"
          onClick={() =>
            navigate(
              user?.role_id == 1
                ? "/add-sub-categories"
                : "/add-sub-categories-sales",
            )
          }
        />
      </div>

      <div className="my-4">
        <SubCategoriesTable />
      </div>
    </div>
  );
}
